// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: rgb(48,62, 78);
}

a {
  margin-right: 0 !important;
  text-align: center;
}

a:not(:last-of-type) {
  border-right: 1px solid rgb(48,62, 78);
}

footer {
  margin: 0;
  width: 100%
}

h3 {
  text-align: center;
}

.img-direct-mail {
  background: url('/assets/images/icons/direct-mail-product.svg') 70% center;
  background-color: rgb(52, 151, 236);
}

.img-local-listings {
  background: url('/assets/images/icons/local-listings.svg');
  background-size: contain !important;
  background-color: rgb(223, 79, 60);
}

.tile-img {
  background-position: center center;
  background-repeat: no-repeat;
  -ms-background-position-x: 66%;
  background-size: 70% 70%;
}

/* General link style */
.blue-link {
  color: blue;  /* Default color for active links */
  text-decoration: underline;
  cursor: pointer;
}

/* Hover effect for active links */
.blue-link:hover {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

/* Style for disabled links */
.disabled {
  color: inherit;  /* Keep the color the same as the surrounding text or as specified */
  text-decoration: none;
  cursor: not-allowed;
}

/* Prevent any hover effect on disabled links */
.disabled:hover {
  color: inherit;
  text-decoration: none;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/customer/service-box/service-box.component.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,mCAAmC;AACrC;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,WAAW,GAAG,mCAAmC;EACjD,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,cAAc,GAAG,oEAAoE;EACrF,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[":root {\n  --background-color: rgb(48,62, 78);\n}\n\na {\n  margin-right: 0 !important;\n  text-align: center;\n}\n\na:not(:last-of-type) {\n  border-right: 1px solid rgb(48,62, 78);\n}\n\nfooter {\n  margin: 0;\n  width: 100%\n}\n\nh3 {\n  text-align: center;\n}\n\n.img-direct-mail {\n  background: url('/assets/images/icons/direct-mail-product.svg') 70% center;\n  background-color: rgb(52, 151, 236);\n}\n\n.img-local-listings {\n  background: url('/assets/images/icons/local-listings.svg');\n  background-size: contain !important;\n  background-color: rgb(223, 79, 60);\n}\n\n.tile-img {\n  background-position: center center;\n  background-repeat: no-repeat;\n  -ms-background-position-x: 66%;\n  background-size: 70% 70%;\n}\n\n/* General link style */\n.blue-link {\n  color: blue;  /* Default color for active links */\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Hover effect for active links */\n.blue-link:hover {\n  color: blue;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Style for disabled links */\n.disabled {\n  color: inherit;  /* Keep the color the same as the surrounding text or as specified */\n  text-decoration: none;\n  cursor: not-allowed;\n}\n\n/* Prevent any hover effect on disabled links */\n.disabled:hover {\n  color: inherit;\n  text-decoration: none;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
